import DonutSmallOutlinedIcon from "@mui/icons-material/DonutSmallOutlined"
import { Box, Typography } from "@mui/material"

import React, { useContext } from "react"
import { customPalette } from "../../../../../../../theme"
import { BSVariantListContext } from "../../../../../../core/context/beem-shot/BSVariant/BSVariantListContext"
import { formatToFrench, stringToDate } from "../../../../../../core/services/date-service"

export function ProjectVariantDisplayerCard(): React.JSX.Element {
  const { bsVariants } = useContext(BSVariantListContext)

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      alignContent="center"
      p={3}
      borderRadius={2}
      sx={{ background: customPalette.lightBlue2 }}>
      <Box display="flex" alignSelf="flex-start" gap={1} pt={1}>
        <Typography variant="subtitle1" sx={{ color: customPalette.white }}>
          Dernières estimations créées
        </Typography>
      </Box>

      {bsVariants.length === 0 ? (
        <Box height="100%" display="flex" justifyContent="center" alignItems="center">
          <Typography variant="subtitle2">Aucune estimation n'a été créée</Typography>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={1} pt={1}>
          {bsVariants.slice(0, 3).map((x) => (
            <Box
              key={x.id}
              borderRadius={2}
              display="flex"
              alignItems="center"
              p={1}
              gap={1}
              sx={{ background: customPalette.white }}>
              <DonutSmallOutlinedIcon
                sx={{ width: "40px", height: "40px", color: customPalette.darkBlue2, strokeWidth: "0.5" }}
              />

              <Box>
                <Typography variant="body2" fontSize={12}>
                  {x.name}
                </Typography>
                <Typography variant="body2" fontSize={11} sx={{ color: customPalette.lightBlue2 }}>
                  Créé le {formatToFrench(stringToDate(x.lastModifiedDate))}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
